const API_URL = process.env.REACT_APP_BACKEND_URL;

// Resolve an image path: external URLs are used as-is, local upload paths
// (e.g. /api/uploads/...) are prefixed with the backend URL.
export const resolveImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return `${API_URL}${url}`;
};

export const fetchDestinations = async () => {
  const response = await fetch(`${API_URL}/api/destinations`);
  if (!response.ok) throw new Error('Failed to fetch destinations');
  return response.json();
};

export const fetchItineraries = async (destinationId) => {
  const query = destinationId ? `?destination_id=${destinationId}` : '';
  const response = await fetch(`${API_URL}/api/itineraries${query}`);
  if (!response.ok) throw new Error('Failed to fetch itineraries');
  return response.json();
};

export const fetchAbout = async () => {
  const response = await fetch(`${API_URL}/api/about`);
  if (!response.ok) throw new Error('Failed to fetch about content');
  return response.json();
};

export const fetchBlogPosts = async () => {
  const response = await fetch(`${API_URL}/api/blog`);
  if (!response.ok) throw new Error('Failed to fetch blog posts');
  return response.json();
};

export const fetchBlogPost = async (slug) => {
  const response = await fetch(`${API_URL}/api/blog/${slug}`);
  if (!response.ok) throw new Error('Failed to fetch blog post');
  return response.json();
};

export const fetchGallery = async () => {
  const response = await fetch(`${API_URL}/api/gallery`);
  if (!response.ok) throw new Error('Failed to fetch gallery');
  return response.json();
};

export const fetchServices = async () => {
  const response = await fetch(`${API_URL}/api/services`);
  if (!response.ok) throw new Error('Failed to fetch services');
  return response.json();
};

export const fetchVisas = async () => {
  const response = await fetch(`${API_URL}/api/visas`);
  if (!response.ok) throw new Error('Failed to fetch visas');
  return response.json();
};
